import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { AlertTriangle, Check, ArrowRight } from 'lucide-react';
export function PricingWidget() {
  const CART_URL = 'https://pagos.avanzalab.online/cart/52985716146490:1';
  return <div id="compra" className="w-full bg-black text-white py-16 px-4" data-id="element-151">
      <div className="max-w-3xl mx-auto bg-[#111] border-2 border-amber-600 rounded-2xl p-6 md:p-10 shadow-2xl shadow-amber-900/20 relative overflow-hidden" data-id="element-152">
        {/* Badge */}
        <div className="absolute top-0 right-0 bg-amber-500 text-black font-bold px-4 py-1 rounded-bl-lg text-sm md:text-base" data-id="element-153">
          56% OFF - OFERTA FLASH
        </div>

        <div className="text-center mb-8" data-id="element-154">
          <h3 className="text-2xl md:text-3xl font-bold mb-2 text-gray-400" data-id="element-155">
            Precio habitual
          </h3>
          <p className="text-4xl md:text-5xl font-bold text-gray-600 line-through decoration-red-500 decoration-4 mb-6" data-id="element-156">
            $47.000 ARS
          </p>

          <h3 className="text-3xl md:text-4xl font-bold mb-2 text-white" data-id="element-157">
            Precio de hoy
          </h3>
          <p className="text-6xl md:text-7xl font-black text-green-500 mb-4 tracking-tight" data-id="element-158">
            $19.990 ARS
          </p>

          <div className="inline-block bg-green-900/50 text-green-400 px-4 py-2 rounded-full font-bold border border-green-700" data-id="element-159">
            Descuento lanzamiento 56%
          </div>
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-amber-900/40 my-8" data-id="element-160"></div>

        {/* Scarcity */}
        <div className="bg-red-900/30 border border-red-800 rounded-lg p-4 mb-8" data-id="element-161">
          <div className="flex items-center justify-center gap-2 text-red-400 font-bold mb-2 text-lg" data-id="element-162">
            <AlertTriangle className="w-6 h-6" data-id="element-163" />⚠ Últimos cupos disponibles
          </div>

          <div className="flex justify-between text-sm text-gray-300 mb-2" data-id="element-164">
            <span data-id="element-165">DESCARGAS</span>
            <span className="font-bold text-white" data-id="element-166">10 disponibles</span>
          </div>

          <div className="w-full bg-gray-800 rounded-full h-4 mb-2" data-id="element-167">
            <div className="bg-red-600 h-4 rounded-full w-[85%] animate-pulse" data-id="element-168"></div>
          </div>

          <p className="text-center text-sm text-gray-400" data-id="element-169">
            Alta demanda — acceso limitado
          </p>
        </div>

        {/* Timer */}
        <div className="text-center mb-8" data-id="element-170">
          <p className="text-gray-400 mb-2 uppercase tracking-widest text-sm" data-id="element-171">
            Tiempo restante
          </p>
          <CountdownTimer size="lg" className="text-amber-500" data-id="element-172" />
          <p className="text-xs text-gray-500 mt-2" data-id="element-173">Se reinicia al finalizar</p>
        </div>

        {/* CTA Button */}
        <a href={CART_URL} className="block w-full bg-amber-500 hover:bg-amber-400 text-black text-2xl md:text-3xl font-black py-6 px-4 rounded-xl shadow-[0_4px_0_rgb(146,100,10)] hover:shadow-[0_2px_0_rgb(146,100,10)] hover:translate-y-[2px] transition-all text-center mb-4 flex items-center justify-center gap-3" data-id="element-174">
          👉 AGREGAR AL CARRITO
        </a>

        <div className="flex justify-center items-center gap-4 text-gray-500 text-sm" data-id="element-175">
          <div className="flex items-center gap-1" data-id="element-176">
            <Check className="w-4 h-4" data-id="element-177" /> Pago Seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-178">
            <Check className="w-4 h-4" data-id="element-179" /> Entrega Inmediata
          </div>
          <div className="flex items-center gap-1" data-id="element-180">
            <Check className="w-4 h-4" data-id="element-181" /> Garantía
          </div>
        </div>
      </div>
    </div>;
}